import React, { Component } from 'react';

export default class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
      timeColor: '#000000',
      expired: 'Expires: ',
      expiredColor: '#000000',
      loadingTimer: true
    };
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs) {
    // let hours = Math.floor(secs / (60 * 60));


    // use moment.js to display time left on the timer for hours, days, weeks, months

    // if it expires less than 6 months and more than one month then show months + weeks + days until it expires

    // if it expires in less than one month and more than 7 days then show weeks + days until it expires

    // if it expires in less than 7 days and more than 1 day then show days left until it expires

    // if it expires in less than 24 hours and more than one hour then show hours left until it expires

    // we're already showing minutes and seconds left if it expires in less than an hour


    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    // if there's less than 5 minutes, then show the timer in red
    if (secs < 300) {this.setState({timeColor: '#d9534f'});}

    // if there's more than 60 seconds, then show the minutes and the seconds remaining
    if (secs >= 60) {return minutes + 'm:' + seconds + 's';}

    // if there's less than 60 seconds and still time remaining, then just show the seconds on the timer
    if (secs >= 1 && secs < 60) {return seconds + 's';}
    // if there is less than 1 second remaining then send a prop back to the parent
    // component so we can render the parent component as 'EXPIRED' in the parent

    if (secs < 1) {
      // send a prop function back to the parent component so the list item is re-rendered and displayed as EXPIRED
      this.setState({expiredColor: '#d9534f', expired: 'EXPIRED'});
      // reload the certifications list by passing a value to the prop function, which will force a re-render of the parent component that the prop is passed from
      this.props.certificationUpdated(Date.now());
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = Math.floor((this.props.expiration - new Date()) / 1000) - 1;

    this.setState({time: this.secondsToTime(seconds)});

    // Check if we're at less than 3 seconds after the timer should of expired.
    // this will give us enough time to ensure the parent component has rendered the expired certification and removed it from the list
    if (seconds < -3) {clearInterval(this.timer);}
  }

  componentDidMount() {
    if (Math.floor((this.props.expiration - new Date()) / 1000) > -10) {
      this.setState({time: this.secondsToTime(Math.floor((this.props.expiration - new Date()) / 1000))});
    }
    if (this.timer === 0 && Math.floor((this.props.expiration - new Date()) / 1000) > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
    this.setState({loadingTimer: false});
  }

  render() {
    return (
      <span>
        {!this.state.loadingTimer &&
        <span><b style={{color:this.state.expiredColor}}>{this.state.expired}</b>
          <span style={{color:this.state.timeColor}}>
            {this.state.time}
          </span>
        </span>}
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Profile/CountdownTimer.js